import { __assign } from "tslib";
import { createHttpTestKit } from "./../http/test-kit";
import { createWasabiApi, } from ".";
import { createFakeDeleteResponder, createFakeGetResponder, createFakePostResponder, createFakePutResponder, } from "..";
export var createWasabiApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWasabiApi(fakeHttp);
    var testKit = {
        whenCreateDashboard: function (dto) {
            return createFakePostResponder(fakeHttp, "/apps/wasabi/dashboards")(dto);
        },
        whenEditDashboard: function (dto) {
            return createFakePutResponder(fakeHttp, "/apps/wasabi/dashboards/".concat(dto !== "*" && dto.dashboardId))(dto);
        },
        whenGetAll: function (dto) {
            if (dto === "*") {
                return createFakeGetResponder(fakeHttp, dto);
            }
            else {
                return createFakeGetResponder(fakeHttp, "/apps/wasabi/getAll?tenantId=".concat(dto.tenantId));
            }
        },
        whenDelete: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "https://".concat(dto !== "*" && dto.defaultHost, "/apps/wasabi/dashboards/").concat(dto !== "*" && dto.dashboardId));
        },
        whenDuplicate: function (dto) {
            return createFakePostResponder(fakeHttp, "/apps/wasabi/dashboards/".concat(dto !== "*" && dto.dashboardId, "/duplicate"))({
                tenantId: (dto !== "*" && dto.tenantId) || "",
                title: (dto !== "*" && dto.title) || "",
                description: (dto !== "*" && dto.description) || "",
                isDefault: (dto !== "*" && dto.isDefault),
            });
        },
        whenGetAllSchedules: function (dto) {
            if (dto === "*") {
                return createFakeGetResponder(fakeHttp, dto);
            }
            else {
                return createFakeGetResponder(fakeHttp, "/apps/wasabi/schedules?tenantId=".concat(dto.tenantId, "&userEmail=").concat(dto.userEmail));
            }
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map